module.exports = __webpack_public_path__ + "static/20220512-thumbnail-aecfefd942286563a8bd46e600d1cba7.jpg";